import withTabHeader from './with-tab-header';

export default withTabHeader;